const CLICK_SAVE_STATUS = 'isSave/CLICK_SAVE_STATUS';

const initialState = {
    saveStatus: false
};
const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case CLICK_SAVE_STATUS:
        return Object.assign({}, state, {
            saveStatus: action.saveStatus
        });
    default:
        return state;
    }
};
const setSaveStatus = saveStatus => {
    return {
        type: CLICK_SAVE_STATUS,
        saveStatus: saveStatus
    };
   
};

export {
    reducer as default,
    initialState as isSaveInitialState,
    setSaveStatus
};
